import { render } from "./RiProdcategory27.vue?vue&type=template&id=0b38ce67"
import script from "./RiProdcategory27.vue?vue&type=script&lang=js"
export * from "./RiProdcategory27.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory27.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b38ce67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b38ce67', __exports__)) {
    api.reload('0b38ce67', __exports__)
  }
  
  module.hot.accept("./RiProdcategory27.vue?vue&type=template&id=0b38ce67", () => {
    api.rerender('0b38ce67', render)
  })

}


export default __exports__